import { defineMessages } from 'react-intl';
export const issueTypeMessages = defineMessages({
	todoColumnName: {
		id: 'jira.madlib.issue-type.todo-column-name',
		defaultMessage: 'To Do',
		description: 'To Do column name',
	},
	inProgressColumnName: {
		id: 'jira.madlib.issue-type.in-progress-column-name',
		defaultMessage: 'In Progress',
		description: 'In Progress column name',
	},
	doneColumnName: {
		id: 'jira.madlib.issue-type.done-column-name',
		defaultMessage: 'Done',
		description: 'Done column name',
	},
});

export const manualIssueMessages = defineMessages({
	summary: {
		id: 'jira.madlib.manual-issue.summary',
		defaultMessage: 'Add work to tracking tool',
		description: 'Summary for the manually created issue',
	},
	description: {
		id: 'jira.madlib.manual-issue.description',
		defaultMessage: 'Break down work into tasks in Jira to organize work and stay aligned.',
		description: 'Description for the manually created issue',
	},
});
